import { useState } from 'react'
import type { FlightSearchProps, CheapFlight } from '../Types'

export default function FlightSearch({ destinations = [] }: FlightSearchProps) {
  const [query, setQuery] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const filtered = query.length > 1
    ? destinations
        .filter(d => d.adv_dest.toLowerCase().includes(query.toLowerCase()))
        .slice(0, 8)
    : []

  const handleSelect = (dest: CheapFlight) => {
    setQuery(dest.adv_dest)
    setIsOpen(false)
    if (dest.DocumentLink) {
      window.location.href = dest.DocumentLink
    } else if (dest.cat_category) {
      window.location.href = `/flights/${dest.cat_category}`
    }
  }

  return (
    <div className="container p-0">
      <section className="row no-gutters">
        <div className="col-12 col-lg-8 mx-auto">
          <div className="search-flights form-group d-flex position-relative">
            <input
              type="search"
              className="form-control w-100 p-3 bg-opacity-75"
              id="flightsearch"
              placeholder="Where do you want to go...."
              value={query}
              autoComplete="off"
              onChange={e => { setQuery(e.target.value); setIsOpen(true) }}
              onFocus={() => setIsOpen(true)}
              onBlur={() => setTimeout(() => setIsOpen(false), 150)}
            />
            {isOpen && filtered.length > 0 && (
              <ul className="dropdown-menu show w-100 position-absolute" style={{ top: '100%', zIndex: 1000 }}>
                {filtered.map((dest, i) => (
                  <li key={i}>
                    <button
                      type="button"
                      className="dropdown-item"
                      onMouseDown={() => handleSelect(dest)}
                    >
                      {dest.adv_dest}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </section>
    </div>
  )
}
